import React from 'react';
//Styles
import './Team.css';
//Component
import Header from '../Header/Header';
//Data
import { STAFF } from '../../shared/staff';


const renderStaffs = staffs => staffs.map(staff => 
    <div className="staff__card">
        <img src={staff.image} />
        <div className="staff__details">
            <h2>{staff.title} <br/>Meet {staff.name}</h2>
            <h4>{staff.description}</h4>
            <div className="staff__email"><a href={"mailto:" + staff.email}>EMAIL {staff.name}</a></div>
        </div>
    </div>
    );




const Team = () => {
    const staffs = STAFF;
    const staffCards = renderStaffs(staffs);
        
    return (
        <>
        <Header color={'var(--DarkNavy)'} barColor={'var(--Blue)'}  bg={'block'}/>
        <div className="team__wrapper">
            <div className="team__content">
                <div className="team__text">
                    <h1 className="team__bigtitle">Meet Our Team Member</h1>
                    <h3 className="team__description">Each of our staffs is handling specific issue to support your business.</h3>
                </div>
                <div className="staff__grid ">
                    {staffCards}
                </div>
            </div>
        </div>
        </>
    );
}

export default Team;